import type { ReactNode } from 'react';

export const symbol_folder_check_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-220v-520 269-18 269Zm0 60q-24 0-42-18.5T80-220v-520q0-23 18-41.5t42-18.5h256q12.44 0 23.72 5t19.37 13.09L481-740h339q23 0 41.5 18.5T880-680v197q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-197H481q-12.44 0-23.72-5t-19.37-13.09L396-740H140v520h307q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H140Zm558-46-45-45q-6-6-14-6t-14 6q-6 6-6 14t6 14l52 52q9 9 21 9t21-9l106-107q6-5.82 6-13.91T825-306q-6-6-14-6t-14 6l-99 100Zm164.5-166.5Q919-316 919-235T862.5-97.5Q806-41 725-41T587.5-97.5Q531-154 531-235t56.5-137.5Q644-429 725-429t137.5 56.5Z"
		/>
	</svg>
);
